export default "__VITE_ASSET__CFStL0_x__"